module.exports = __webpack_public_path__ + "static/media/pub_restaurant_reopening.71047d51.webp";